import React from "react";
import { useMsal } from "@azure/msal-react";
import arrow from "../assets/arrow.svg";

/**
 * Renders a sign-out button
 */
export const SignOutButton = () => {
    const { instance } = useMsal();

    const handleLogout = (logoutType) => {
        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/expense-tool",
            });
        }
    }
    return (
        
        <button   
        className="button" 
        onClick={() => handleLogout("redirect")}>   
             Sign out &nbsp; 
        <img src={arrow} alt='#'/>
            </button>
    )
}